import { withModalProvider } from "../../hoc/withModalProvider";

import { ApplyToOthersModal as View, IProps } from "./ApplyToOthersModal";

export const ApplyToOthersModal = withModalProvider<IProps>(View);
